import React, { FC } from 'react';
import {
    MotifErrorMessage,
    MotifFormField,
    MotifFileUploader,
    MotifIcon,
    MotifFileUploaderItem
} from '@ey-xd/motif-react';
import { actionIcDescription24px } from '@ey-xd/motif-react/assets/icons';

import { FileDetails } from 'common/models';

import './FileUploader.scss';

type FileUploaderProps = {
    maxFiles?: number;
    uploadingFiles?: Array<FileDetails>;
    selectedFiles?: Array<FileDetails>;
    errorMessage?: string;
    onSelectedFileRemove?: (file: FileDetails) => void;
    onUploadingFileRemove?: (file: FileDetails) => void;
    onDrop?: (files: Array<FileDetails>) => void;
    uploadText?: string;
};

const FileUploader: FC<FileUploaderProps> = ({
    maxFiles,
    uploadingFiles,
    selectedFiles,
    errorMessage,
    onSelectedFileRemove,
    onUploadingFileRemove,
    onDrop,
    uploadText,
    ...other
}: FileUploaderProps) => {
    return (
        <MotifFileUploader
            id="file-uploader"
            key="file-uploader"
            label={`${uploadText ? uploadText : 'Drag and drop an excel or browse'}`}
            maxFiles={maxFiles}
            onDrop={onDrop}>
            {selectedFiles?.map((file: FileDetails) => {
                return (
                    <MotifFileUploaderItem
                        key={file.path}
                        aria-label={`Click to remove file - ${file.name}`}
                        uploaded
                        removable
                        fileName={file.name}
                        fileSize={file.size}
                        fileIcon={<MotifIcon src={actionIcDescription24px} {...other} />}
                        onRemove={onSelectedFileRemove?.(file)}>
                        {file.name}
                    </MotifFileUploaderItem>
                );
            })}
            {uploadingFiles?.map((file: FileDetails) => {
                return (
                    <MotifFileUploaderItem
                        showProgress
                        key={file.path}
                        percentUploaded={file.progress}
                        aria-label={`Click to remove file - ${file.name}`}
                        uploaded={file.progress === 100}
                        fileName={file.name}
                        fileSize={file.size}
                        fileIcon={<MotifIcon src={actionIcDescription24px} {...other} />}
                        onRemove={onUploadingFileRemove?.(file)}>
                        {file.name}
                    </MotifFileUploaderItem>
                );
            })}
            {errorMessage && <MotifErrorMessage>{errorMessage}</MotifErrorMessage>}
        </MotifFileUploader>
    );
};

export default FileUploader;
